var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',{attrs:{"md":"12","lg":"7","order-lg":"1","order":"2","mb-3":""}},[_c('Map')],1),_c('b-col',{staticClass:"text-center",attrs:{"md":"12","lg":"4","order-lg":"2","order":"1","mb-3":""}},[_c('h2',[_c('WeddingDate')],1),_c('br'),_c('Calendar',{attrs:{"attributes":_vm.attributes,"from-page":{
          month: _vm.month,
          year: _vm.year,
        },"disable-page-swipe":""}}),_c('br'),_c('br'),_c('h3',[_c('Countdown')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }